import { render, staticRenderFns } from "./permissionData.vue?vue&type=template&id=463437ad"
import script from "./permissionData.vue?vue&type=script&lang=js"
export * from "./permissionData.vue?vue&type=script&lang=js"
import style0 from "./permissionData.vue?vue&type=style&index=0&id=463437ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports